/**
 * contains the abi and contract address
*/

class MonthlyIndexContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "ipfsHash",
				"type": "bytes32"
			},
			{
				"name": "month",
				"type": "uint32"
			},
			{
				"name": "year",
				"type": "uint32"
			}
		],
		"name": "newMonthlyIndex",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"name": "sampleHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "month",
				"type": "uint32"
			},
			{
				"indexed": true,
				"name": "year",
				"type": "uint64"
			}
		],
		"name": "NewMonthlyIndex",
		"type": "event"
	}
        ];
            
        this.contractAddress = '0xfaa21e766f988524d3f38b9c46c22aca11d76dd5';
    }
}

export default MonthlyIndexContract;
	
